import React, { FC, ReactElement } from 'react'

export const DeletePreview: FC = (): ReactElement => (
    <svg viewBox='0 0 900.000000 900.000000' preserveAspectRatio='xMidYMid meet'>
        <g transform='translate(0.000000,900.000000) scale(0.100000,-0.100000)' fill='#000000' stroke='none'>
            <path
                d='M1311 8520 c-45 -10 -97 -24 -115 -30 -87 -33 -183 -75 -197 -87 -8
-7 -18 -13 -22 -13 -20 0 -144 -97 -218 -171 -73 -72 -169 -196 -169 -216 0
-4 -6 -14 -13 -22 -14 -16 -46 -88 -79 -176 -10 -27 -27 -92 -38 -144 -20 -93
-20 -143 -20 -3171 0 -2967 1 -3080 19 -3166 23 -113 42 -169 92 -272 57 -118
112 -194 209 -292 160 -160 335 -253 564 -301 86 -18 199 -19 3166 -19 3028 0
3078 0 3171 20 52 11 119 29 149 41 30 11 64 23 75 27 11 3 42 18 68 34 26 15
50 28 52 28 19 0 146 100 215 170 74 73 170 197 170 217 0 4 6 14 13 22 14 16
46 88 79 176 10 28 27 92 38 144 20 93 20 143 20 3171 0 2967 -1 3080 -19
3166 -67 321 -244 569 -526 741 -40 24 -95 48 -213 94 -12 5 -66 18 -119 29
-95 20 -126 20 -3182 19 -2940 -1 -3090 -2 -3170 -19z m6251 -716 c24 -9 57
-23 73 -31 34 -18 125 -103 125 -117 0 -5 6 -17 13 -25 7 -9 21 -39 30 -66 15
-43 17 -83 15 -255 l-3 -205 -3325 0 -3325 0 -3 205 c-3 213 1 241 45 325 19
36 103 125 118 125 6 0 16 5 23 12 6 6 33 19 59 29 45 16 217 17 3080 18 2741
1 3037 -1 3075 -15z m256 -3884 c2 -2294 1 -2458 -15 -2505 -9 -27 -23 -57
-30 -66 -7 -8 -13 -20 -13 -24 0 -13 -92 -105 -105 -105 -6 0 -16 -5 -22 -11
-7 -7 -36 -20 -65 -30 -50 -18 -157 -19 -3078 -19 -2921 0 -3028 1 -3078 19
-29 10 -58 23 -65 30 -6 6 -16 11 -21 11 -14 0 -106 91 -106 105 0 6 -5 16
-11 22 -7 7 -20 36 -30 65 -18 50 -19 142 -19 2503 0 1349 3 2455 7 2458 3 4
1501 6 3327 5 l3321 -3 3 -2455z'
            />
            <path
                d='M6245 6025 c-109 -22 -156 -56 -351 -250 -239 -238 -390 -382 -443
-424 -24 -18 -56 -52 -73 -75 -41 -57 -856 -876 -872 -876 -7 0 -44 33 -82 73
-329 345 -1430 1435 -1495 1479 -102 69 -293 91 -408 47 -178 -67 -291 -239
-278 -423 9 -139 67 -236 236 -396 213 -201 1392 -1389 1399 -1409 2 -5 -345
-357 -771 -783 -719 -718 -776 -778 -805 -838 -61 -133 -63 -298 -5 -414 81
-160 270 -256 447 -225 136 24 156 38 446 324 146 143 269 267 274 275 14 25
420 430 431 430 5 0 142 135 304 300 161 165 299 300 305 300 22 0 390 -377
401 -411 6 -18 18 -35 26 -37 13 -4 80 -67 424 -397 80 -77 153 -143 163 -147
9 -4 55 -48 102 -99 169 -182 426 -437 467 -462 78 -49 148 -67 258 -67 77 0
113 5 154 21 171 64 271 211 271 397 0 98 -17 161 -65 234 -32 50 -696 733
-955 983 -341 329 -610 600 -610 615 0 14 300 322 740 758 681 675 798 796
828 857 37 76 52 138 52 220 0 147 -56 265 -163 343 -65 47 -115 68 -191 82
-70 12 -82 12 -161 -5z'
            />
            <path
                d='M4185 5554 c-60 -8 -139 -21 -175 -29 -36 -8 -74 -15 -84 -15 -36 0
-249 -65 -253 -77 -2 -5 35 -45 82 -88 46 -44 180 -174 297 -288 l213 -208
220 -3 c121 -2 230 -6 242 -10 19 -7 42 13 175 148 280 286 418 433 418 445 0
6 -6 13 -12 15 -7 2 -38 10 -68 19 -346 98 -735 132 -1055 91z'
            />
            <path
                d='M2517 4718 c-146 -145 -229 -241 -353 -408 -195 -263 -284 -430 -284
-535 0 -66 57 -207 120 -302 17 -24 30 -46 30 -48 0 -19 189 -271 298 -398
104 -121 287 -307 303 -307 7 0 124 112 260 248 l249 249 -123 124 c-101 102
-168 179 -250 284 -58 75 -96 133 -96 145 0 13 26 52 111 165 69 90 143 172
248 276 l118 116 -252 252 c-138 138 -254 251 -258 251 -4 0 -58 -51 -121
-112z'
            />
            <path
                d='M6179 4627 c-96 -94 -206 -199 -242 -232 -37 -33 -70 -67 -72 -76 -4
-11 28 -50 98 -120 94 -94 172 -181 235 -264 84 -112 111 -152 112 -164 0 -27
-198 -277 -319 -402 l-120 -124 32 -33 c18 -19 92 -93 165 -167 72 -73 132
-137 132 -142 0 -4 38 -46 84 -92 l84 -84 104 104 c141 142 225 240 344 399
212 286 294 449 281 561 -7 60 -48 164 -96 241 -20 32 -41 67 -46 76 -61 102
-186 270 -300 402 -114 132 -270 290 -286 290 -8 0 -93 -78 -190 -173z'
            />
            <path
                d='M4023 2472 c-126 -123 -258 -252 -295 -288 -38 -35 -68 -68 -68 -73
0 -5 10 -12 23 -16 49 -13 134 -38 177 -51 25 -8 55 -14 68 -14 13 0 51 -6 85
-14 263 -60 684 -60 957 0 36 8 74 14 86 14 11 0 40 6 65 14 24 8 81 24 127
37 53 15 82 28 82 37 0 16 -83 100 -149 152 -25 19 -97 87 -161 152 -64 65
-121 118 -126 118 -5 0 -43 34 -85 76 l-77 77 -241 1 -241 1 -227 -223z'
            />
        </g>
    </svg>
)
